import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { GestionStagiairesComponent } from './gestion-stagiaires.component'
import { ListeStagiairesComponent } from './liste-stagiaires/liste-stagiaires.component';
import { AddNewStagiaireComponent } from './add-new-stagiaire/add-new-stagiaire.component';


const routesStagiaires: Routes = [
  {
    path: '',
    component: GestionStagiairesComponent
  },
  {
    path: 'liste_stagiaires',
    component: ListeStagiairesComponent
  },
  {
    path: 'ajoutNouveau',
    component: AddNewStagiaireComponent
  }
];

export const gestionStagiairesRouting: ModuleWithProviders = RouterModule.forChild(routesStagiaires);




// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/gestion-stagiaires/gestion-stagiaires.routes.ts